import _ from 'lodash';
import { ReactElement } from 'react';

import {
  Language,
  SchedulingBestMomentType,
  SchedulingTimeFrame,
  SchedulingTimeFrames,
  SchedulingTimeOfDay,
} from '@breathelife/types';

import {
  CenteredText,
  Container,
  ScheduleTable,
  ScheduleTableBody,
  ScheduleTableColumnHeader,
  ScheduleTableColumnHeaderItem,
  ScheduleTableHelpTextContainer,
} from './Styles';
import { TimeButton } from './TimeButton/TimeButton';
import { weekdays } from './Weekdays';

const timesOfDay: SchedulingTimeOfDay[] = ['morning', 'day', 'evening'];

const renderMorningSvgData = (): ReactElement => (
  <svg width='24' height='18' viewBox='0 0 24 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g className='inside'>
      <path d='M18.5015 11.7578C18.5015 13.7828 17.58 15.5926 16.1336 16.7907C15.0031 17.7271 13.552 16.7907 11.9694 16.7907C10.3868 16.7907 8.93561 17.7271 7.80515 16.7907C6.35869 15.5926 5.43726 13.7828 5.43726 11.7578C5.43726 8.15023 8.36178 5.22571 11.9694 5.22571C15.577 5.22571 18.5015 8.15023 18.5015 11.7578Z' />
    </g>
    <g className='outline'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.129883 17.0651C0.129883 16.6593 0.458892 16.3303 0.864745 16.3303H23.1332C23.5391 16.3303 23.8681 16.6593 23.8681 17.0651C23.8681 17.471 23.5391 17.8 23.1332 17.8H0.864745C0.458892 17.8 0.129883 17.471 0.129883 17.0651Z'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.999 0C12.4049 0 12.7339 0.329009 12.7339 0.734862V2.21943C12.7339 2.62528 12.4049 2.95429 11.999 2.95429C11.5932 2.95429 11.2642 2.62528 11.2642 2.21943V0.734862C11.2642 0.329009 11.5932 0 11.999 0Z'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M20.392 3.47665C20.6788 3.76377 20.6786 4.22906 20.3915 4.5159L19.3414 5.565C19.0543 5.85184 18.589 5.85162 18.3021 5.56451C18.0153 5.27739 18.0155 4.8121 18.3026 4.52525L19.3527 3.47616C19.6398 3.18931 20.1051 3.18953 20.392 3.47665Z'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M20.9138 11.8691C20.9138 11.4632 21.2428 11.1342 21.6487 11.1342H23.1332C23.5391 11.1342 23.8681 11.4632 23.8681 11.8691C23.8681 12.2749 23.5391 12.6039 23.1332 12.6039H21.6487C21.2428 12.6039 20.9138 12.2749 20.9138 11.8691Z'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.129883 11.8691C0.129883 11.4632 0.458892 11.1342 0.864745 11.1342H2.34931C2.75516 11.1342 3.08417 11.4632 3.08417 11.8691C3.08417 12.2749 2.75516 12.6039 2.34931 12.6039H0.864745C0.458892 12.6039 0.129883 12.2749 0.129883 11.8691Z'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.60586 3.47665C3.89271 3.18953 4.358 3.18931 4.64511 3.47616L5.69519 4.52525C5.98231 4.8121 5.98253 5.27739 5.69568 5.56451C5.40884 5.85162 4.94355 5.85184 4.65643 5.565L3.60635 4.5159C3.31923 4.22906 3.31901 3.76377 3.60586 3.47665Z'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.57064 5.21969C9.62912 4.66782 10.8052 4.37964 11.9989 4.37964C13.1926 4.37964 14.3687 4.66782 15.4272 5.21969C16.4856 5.77156 17.3952 6.57081 18.0787 7.54951C18.7621 8.52822 19.1992 9.65745 19.3527 10.8412C19.5062 12.025 19.3717 13.2284 18.9606 14.3491C18.8208 14.7301 18.3986 14.9257 18.0176 14.7859C17.6366 14.6461 17.441 14.2239 17.5808 13.8429C17.9104 12.9443 18.0183 11.9795 17.8952 11.0303C17.7721 10.0811 17.4216 9.1757 16.8737 8.39097C16.3257 7.60625 15.5964 6.96541 14.7477 6.52292C13.899 6.08043 12.956 5.84936 11.9989 5.84936C11.0418 5.84936 10.0988 6.08043 9.25012 6.52292C8.40143 6.96541 7.67211 7.60624 7.12413 8.39097C6.57615 9.1757 6.22572 10.0811 6.10261 11.0303C5.9795 11.9795 6.08736 12.9443 6.41701 13.8429C6.55679 14.2239 6.36123 14.6461 5.98021 14.7859C5.59919 14.9257 5.177 14.7301 5.03721 14.3491C4.62607 13.2284 4.49155 12.025 4.64509 10.8412C4.79863 9.65745 5.23569 8.52822 5.91912 7.54951C6.60256 6.57081 7.51216 5.77156 8.57064 5.21969Z'
      />
    </g>
  </svg>
);
const renderDaySvgData = (): ReactElement => (
  <svg width='25' height='25' viewBox='0 0 25 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g className='inside'>
      <path d='M12.0376 18.8256C15.7865 18.8256 18.8256 15.7865 18.8256 12.0375C18.8256 8.28857 15.7865 5.24945 12.0376 5.24945C8.28863 5.24945 5.24951 8.28857 5.24951 12.0375C5.24951 15.7865 8.28863 18.8256 12.0376 18.8256Z' />
    </g>
    <g className='outline'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.0375 5.9735C8.68846 5.9735 5.97351 8.68844 5.97351 12.0375C5.97351 15.3866 8.68846 18.1015 12.0375 18.1015C15.3866 18.1015 18.1015 15.3866 18.1015 12.0375C18.1015 8.68844 15.3866 5.9735 12.0375 5.9735ZM4.52539 12.0375C4.52539 7.88867 7.88868 4.52538 12.0375 4.52538C16.1863 4.52538 19.5496 7.88867 19.5496 12.0375C19.5496 16.1863 16.1863 19.5496 12.0375 19.5496C7.88868 19.5496 4.52539 16.1863 4.52539 12.0375Z'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.0375 0C12.4374 0 12.7616 0.324173 12.7616 0.72406V2.23252C12.7616 2.63241 12.4374 2.95658 12.0375 2.95658C11.6376 2.95658 11.3135 2.63241 11.3135 2.23252V0.72406C11.3135 0.324173 11.6376 0 12.0375 0Z'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M20.5494 3.52567C20.8321 3.80843 20.8321 4.26688 20.5494 4.54965L19.4824 5.61663C19.1996 5.89939 18.7412 5.89939 18.4584 5.61663C18.1756 5.33387 18.1756 4.87542 18.4584 4.59265L19.5254 3.52567C19.8082 3.24291 20.2666 3.24291 20.5494 3.52567Z'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M21.1184 12.0375C21.1184 11.6376 21.4426 11.3134 21.8425 11.3134H23.3509C23.7508 11.3134 24.075 11.6376 24.075 12.0375C24.075 12.4374 23.7508 12.7616 23.3509 12.7616H21.8425C21.4426 12.7616 21.1184 12.4374 21.1184 12.0375Z'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M18.4584 18.4584C18.7412 18.1756 19.1996 18.1756 19.4824 18.4584L20.5494 19.5254C20.8321 19.8081 20.8321 20.2666 20.5494 20.5493C20.2666 20.8321 19.8082 20.8321 19.5254 20.5493L18.4584 19.4824C18.1756 19.1996 18.1756 18.7411 18.4584 18.4584Z'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.0375 21.1184C12.4374 21.1184 12.7616 21.4426 12.7616 21.8425V23.3509C12.7616 23.7508 12.4374 24.075 12.0375 24.075C11.6376 24.075 11.3135 23.7508 11.3135 23.3509V21.8425C11.3135 21.4426 11.6376 21.1184 12.0375 21.1184Z'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.61651 18.4584C5.89927 18.7411 5.89927 19.1996 5.61651 19.4824L4.54952 20.5493C4.26676 20.8321 3.80831 20.8321 3.52555 20.5493C3.24279 20.2666 3.24279 19.8081 3.52555 19.5254L4.59253 18.4584C4.87529 18.1756 5.33374 18.1756 5.61651 18.4584Z'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0 12.0375C0 11.6376 0.324173 11.3134 0.72406 11.3134H2.23252C2.63241 11.3134 2.95658 11.6376 2.95658 12.0375C2.95658 12.4374 2.63241 12.7616 2.23252 12.7616H0.72406C0.324173 12.7616 0 12.4374 0 12.0375Z'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.52555 3.52567C3.80831 3.24291 4.26676 3.24291 4.54952 3.52567L5.61651 4.59265C5.89927 4.87542 5.89927 5.33387 5.61651 5.61663C5.33374 5.89939 4.87529 5.89939 4.59253 5.61663L3.52555 4.54965C3.24279 4.26688 3.24279 3.80843 3.52555 3.52567Z'
      />
    </g>
  </svg>
);
const renderEveningSvgData = (): ReactElement => (
  <svg width='16' height='20' viewBox='0 0 16 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g className='inside'>
      <path d='M6.8898 2.59191C7.71292 3.74985 8.20288 5.11127 8.3064 6.52818C8.39925 8.01968 8.07023 9.50719 7.35703 10.8204C6.64383 12.1336 5.57527 13.2195 4.27366 13.9537C3.46323 14.4147 2.57376 14.7201 1.6511 14.8541C1.40866 14.8941 1.18424 15.0073 1.00796 15.1784C0.831677 15.3496 0.711967 15.5706 0.664891 15.8117C0.617814 16.0529 0.645625 16.3027 0.744591 16.5276C0.843557 16.7525 1.00894 16.9417 1.21856 17.0699C2.32543 17.7769 3.57326 18.2337 4.87494 18.4086C6.17662 18.5835 7.50078 18.4722 8.755 18.0824C10.0092 17.6927 11.1633 17.0339 12.1366 16.1521C13.1099 15.2703 13.879 14.1867 14.3903 12.9769C14.9015 11.7671 15.1426 10.4603 15.0966 9.14773C15.0507 7.83516 14.7188 6.54844 14.1242 5.37738C13.5296 4.20631 12.6865 3.17914 11.6539 2.36755C10.6213 1.55596 9.42401 0.979515 8.14561 0.678453C7.90167 0.617661 7.64488 0.634202 7.41076 0.725786C7.17664 0.81737 6.97677 0.979467 6.83884 1.18964C6.7009 1.39981 6.63171 1.64767 6.64084 1.8989C6.64997 2.15013 6.73697 2.39231 6.8898 2.59191Z' />
    </g>
    <g className='outline'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.29603 0.0538277C9.66422 0.376532 10.9456 0.993726 12.0508 1.8624C13.1569 2.73176 14.06 3.83206 14.6969 5.08648C15.3339 6.3409 15.6894 7.71923 15.7386 9.12523C15.7878 10.5312 15.5296 11.9311 14.982 13.227C14.4343 14.5229 13.6104 15.6836 12.5678 16.6282C11.5252 17.5728 10.289 18.2785 8.94555 18.696C7.60205 19.1134 6.18363 19.2327 4.78928 19.0454C3.39682 18.8583 2.06189 18.3699 0.877417 17.6144C0.558744 17.4179 0.307276 17.1291 0.156433 16.7863C0.00467127 16.4414 -0.0379738 16.0584 0.0342153 15.6886C0.106404 15.3188 0.289974 14.9799 0.560296 14.7175C0.830617 14.455 1.17475 14.2815 1.54652 14.2202L1.5586 14.2183C2.40202 14.0958 3.21509 13.8166 3.95591 13.3952L3.95791 13.3941C5.15443 12.7192 6.13672 11.721 6.79234 10.5138C7.44741 9.3076 7.7499 7.94149 7.66528 6.57157C7.57003 5.27634 7.12275 4.03177 6.3718 2.97225C6.14281 2.66884 6.0125 2.30229 5.99868 1.92221C5.98472 1.53786 6.09057 1.15866 6.30161 0.837104C6.51264 0.515553 6.81841 0.267558 7.1766 0.127443C7.53324 -0.0120683 7.92427 -0.0377592 8.29603 0.0538277ZM6.88969 2.5919L7.41335 2.21965C8.30452 3.47332 8.83499 4.94729 8.94707 6.48134L8.94757 6.48824L8.94753 6.48824C9.04787 8.10017 8.6923 9.70777 7.92151 11.127C7.15092 12.5459 5.99645 13.7192 4.59021 14.5127C3.71258 15.0117 2.74962 15.3428 1.7507 15.4889C1.63942 15.5082 1.5365 15.5606 1.45541 15.6393C1.37317 15.7192 1.31732 15.8223 1.29536 15.9348C1.2734 16.0473 1.28637 16.1638 1.33254 16.2688C1.37871 16.3737 1.45587 16.462 1.55367 16.5218L1.56428 16.5284C2.59236 17.1851 3.75136 17.6094 4.96038 17.7718C6.1694 17.9343 7.39931 17.8309 8.56424 17.4689C9.72918 17.1069 10.8011 16.495 11.7051 15.676C12.6091 14.8569 13.3235 13.8504 13.7984 12.7268C14.2732 11.6031 14.4971 10.3893 14.4545 9.1702C14.4118 7.95106 14.1035 6.75593 13.5512 5.66823C12.9989 4.58053 12.2159 3.62647 11.2568 2.87266C10.2977 2.11884 9.18563 1.58343 7.99823 1.3038L7.99013 1.30189L7.99014 1.30184C7.87548 1.27326 7.75476 1.28104 7.64471 1.32409C7.53465 1.36714 7.4407 1.44334 7.37586 1.54214C7.31102 1.64093 7.27849 1.75745 7.28279 1.87555C7.28708 1.99365 7.32798 2.10749 7.39982 2.20132L6.88969 2.5919Z'
      />
    </g>
  </svg>
);

const timeSlotIconMap: Record<SchedulingTimeOfDay, () => ReactElement> = {
  morning: renderMorningSvgData,
  day: renderDaySvgData,
  evening: renderEveningSvgData,
};

type DayType = {
  short: string;
  dayIndex: number;
};

type TimeSlot = {
  timeOfDay: SchedulingTimeOfDay;
  day: {
    short: string;
    index: number;
  };
};

type OnPeriodOfTheDayChange = (isChecked: boolean, day: string, period: SchedulingTimeFrame) => void;

type Props = {
  onChange: OnPeriodOfTheDayChange;
  language: Language;
  bestMoments: SchedulingBestMomentType;
  schedulingTimeFrames: SchedulingTimeFrames;
};

const getTimeButtonLabel = (day: string, timeFrame: SchedulingTimeFrame): string => `${day}_${timeFrame.join('-')}`;

export function ScheduleTimeTable(props: Props): ReactElement {
  const days: DayType[] = Object.keys(weekdays).map((key, index) => {
    const localizedShortText = weekdays[key].short;
    return { short: localizedShortText[props.language], dayIndex: index };
  });

  const timeSlots = _.groupBy(
    _.flatMap(
      Object.keys(weekdays).map((key, index): TimeSlot[] => {
        const localizedShortText = weekdays[key].short;
        return timesOfDay.map((timeSlot) => ({
          timeOfDay: timeSlot as SchedulingTimeOfDay,
          day: {
            short: localizedShortText[props.language],
            index,
          },
        }));
      }),
    ),
    'timeOfDay',
  );

  return (
    <Container>
      <ScheduleTable>
        <ScheduleTableColumnHeader>
          <tr>
            {days.map((day) => (
              <ScheduleTableColumnHeaderItem key={day.dayIndex} active={!_.isEmpty(props.bestMoments[day.dayIndex])}>
                {day.short}
              </ScheduleTableColumnHeaderItem>
            ))}
          </tr>
        </ScheduleTableColumnHeader>
        <ScheduleTableBody>
          {Object.entries(props.schedulingTimeFrames).map(([timeOfDay, timeFrameInfo]) => {
            const timeSlot = timeSlots[timeOfDay];
            return (
              <tr key={timeOfDay}>
                {timeSlot.map((timeSlot) => (
                  <TimeButton
                    key={`${timeOfDay}_${timeSlot.day.index}`}
                    ariaLabel={getTimeButtonLabel(timeSlot.day.short, timeFrameInfo.timeFrame)}
                    data-testid={getTimeButtonLabel(timeSlot.day.short, timeFrameInfo.timeFrame)}
                    isChecked={props.bestMoments[timeSlot.day.index]?.some((moment) =>
                      _.isEqual(moment, timeFrameInfo.timeFrame),
                    )}
                    onChange={(isChecked: boolean) => {
                      props.onChange(isChecked, timeSlot.day.index.toString(), timeFrameInfo.timeFrame);
                    }}
                  >
                    {timeSlotIconMap[timeOfDay as SchedulingTimeOfDay]()}
                  </TimeButton>
                ))}
              </tr>
            );
          })}
        </ScheduleTableBody>
      </ScheduleTable>
      <ScheduleTableHelpTextContainer>
        {Object.entries(props.schedulingTimeFrames).map(([timeOfDay, timeFrame]) => (
          <CenteredText key={timeOfDay}>
            {timeSlotIconMap[timeOfDay as SchedulingTimeOfDay]()}
            <span>{timeFrame.description}</span>
          </CenteredText>
        ))}
      </ScheduleTableHelpTextContainer>
    </Container>
  );
}
